"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REDIRECTION_TYPE = exports.LINK_TARGET = exports.LINK_HOVER_BEHAVIOR = void 0;
var LINK_TARGET = {
  tab: {
    type: 'tab',
    code: '_blank'
  },
  self: {
    type: 'self',
    code: '_self'
  },
  parent: {
    type: 'parent',
    code: '_parent'
  },
  callback: {
    type: 'self',
    code: '_self'
  }
};
exports.LINK_TARGET = LINK_TARGET;
var LINK_HOVER_BEHAVIOR = {
  hover: {
    code: 'underlined'
  }
};
exports.LINK_HOVER_BEHAVIOR = LINK_HOVER_BEHAVIOR;
var REDIRECTION_TYPE = {
  normal: 'normal',
  secured: 'secured'
};
exports.REDIRECTION_TYPE = REDIRECTION_TYPE;